/**
 * plugins/webfontloader.js
 *
 * webfontloader documentation: https://github.com/typekit/webfontloader
 */

export async function loadFonts() {
  const webFontLoader = await import(/* webpackChunkName: "webfontloader" */'webfontloader')

  return new Promise((resolve) => {
    webFontLoader.load({
      google: {
        // 400i and 600i added: the designer has a Kursiv checkbox, and
        // without an italic face loaded the canvas could only ever
        // synthesise a slant while the printer used the real
        // Inter-italic file. Different shapes, same label.
        families: ['Inter:400,400i,500,600,600i&display=swap'],
      },

      // Self-hosted licensed fonts. Declared in public/fonts/fonts.css;
      // the family names there must match `cssFamily` in
      // src/utils/fontManifest.js, since canvasRenderer writes them
      // straight into ctx.font.
      //
      // Without this block the browser had never heard of
      // PPRightGroteskBlack and quietly substituted the default sans,
      // so a label set to Compact Black previewed in the wrong face.
      custom: {
        families: [
          'PPRightGroteskBlack',
          'PPRightGroteskDark',
          'PPRightGroteskMedium',
        ],
        urls: ['/fonts/fonts.css'],
      },

      // Resolve either way. A canvas drawn before the fonts are ready
      // measures text in the fallback face and caches the wrong widths,
      // so the designer should await this before its first render — but
      // a font that fails to load must not block the app from starting.
      active: resolve,
      inactive: resolve,
    })
  })
}